import { useReducer } from 'react';
import NotesContext from './notes-context';

const defaultNotesState = {
  notes: [{ title: 'Amar', note: 'Narute', id: 232323, color: 'grey' }],
  searchText: '',
};

const NotesReducer = (state, action) => {
  if (action.type === 'ADD') {
    let updatedNotes;
    action.payload.color = 'default';
    updatedNotes = state.notes.concat(action.payload);
    return {
      notes: updatedNotes,
      searchText: state.searchText,
    };
  }

  if (action.type === 'DELETE') {
    const updatedNotes = state.notes.filter((note) => note.id !== action.id);

    return {
      notes: updatedNotes,
      searchText: state.searchText,
    };
  }

  if (action.type === 'EDIT') {
    const { id, title, note } = action.payload;

    const noteIndex = state.notes.findIndex((note) => {
      return note.id === id;
    });

    let updatedNotes = [...state.notes];

    let updatedNote = state.notes[noteIndex];
    updatedNote.title = title;
    updatedNote.note = note;

    updatedNotes[noteIndex] = updatedNote;

    return {
      notes: updatedNotes,
      searchText: state.searchText,
    };
  }

  if (action.type === 'GET') {
    const note = state.notes.find({ id: action.id });

    return { note };
  }

  if (action.type === 'SET_SEARCH_TEXT') {
    return {
      notes: state.notes,
      searchText: action.text,
    };
  }

  if (action.type === 'SET_COLOR') {
    const { id, color } = action.payload;

    let noteIndex = state.notes.findIndex((note) => note.id === id);

    let updatedNote = state.notes[noteIndex];
    let updatedNotes = [...state.notes];

    updatedNote.color = color;

    updatedNotes[noteIndex] = updatedNote;

    return {
      notes: updatedNotes,
      searchText: state.searchText,
    };
  }
  return defaultNotesState;
};

const NotesProvider = (props) => {
  const [notesState, dispatchNotesAction] = useReducer(
    NotesReducer,
    defaultNotesState
  );

  const addNote = (note) => {
    dispatchNotesAction({ type: 'ADD', payload: note });
  };

  const deleteNote = (id) => {
    dispatchNotesAction({ type: 'DELETE', id: id });
  };

  const editNote = (note) => {
    dispatchNotesAction({ type: 'EDIT', payload: note });
  };

  const getNotes = (id) => {
    const note = notesState.notes.filter((item) => item.id === id);
    return note[0];
  };

  const setSearchText = (searchText) => {
    dispatchNotesAction({ type: 'SET_SEARCH_TEXT', text: searchText });
  };

  const setColor = (info) => {
    dispatchNotesAction({ type: 'SET_COLOR', payload: info });
  };

  const notesContext = {
    notes: notesState.notes,
    addNote,
    getNotes,
    deleteNote,
    editNote,
    searchText: notesState.searchText,
    setSearchText,
    setColor,
  };

  return (
    <NotesContext.Provider value={notesContext}>
      {props.children}
    </NotesContext.Provider>
  );
};

export default NotesProvider;
